<template>
  <div class="relative inline-block" v-click-outside="closeColorPicker">
    <div
      class="color-swatch"
      :class="swatchClass"
      :style="{ backgroundColor: value }"
      @click.stop="showColorPicker = !showColorPicker"
    >
      <slot></slot>
    </div>

    <div
      v-if="showColorPicker"
      class="color-picker-dropdown"
      :class="dropdownPosition"
    >
      <chrome-picker
        :value="colorValue"
        @input="updateColor"
        :disableAlpha="true"
      />
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'SwatchColorPicker',

  props: {
    value: {
      type: String,
      default: "#2D80FA"
    },
    swatchClass: {
      type: String,
      default: "w-9 h-9 rounded-lg flex items-center justify-center cursor-pointer border border-neutral-200 hover:border-neutral-300 transition-colors"
    },
    dropdownPosition: {
      type: String,
      default: "left"
    }
  },

  data() {
    return {
      showColorPicker: false,
      colorValue: {
        hex: this.value
      }
    };
  },

  components: {
    'chrome-picker': Chrome
  },

  watch: {
    value(newVal) {
      this.colorValue = { hex: newVal };
    }
  },

  methods: {
    updateColor(colors) {
      this.colorValue = colors;
      this.$emit('input', colors.hex);
    },

    closeColorPicker() {
      this.showColorPicker = false;
    }
  }
};
</script>

<style scoped>
.color-swatch {
  position: relative;
}

.color-picker-dropdown {
  position: absolute;
  z-index: 50;
  margin-top: 0.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  overflow: hidden;
}

.color-picker-dropdown.left {
  left: 0;
}

.color-picker-dropdown.right {
  right: 0;
}

.color-picker-dropdown.center {
  left: 50%;
  transform: translateX(-50%);
}
</style>
